import { IconBirthdayCake } from '@medifind/icons';
import { Select } from '@medifind/shared-basic-components';
import { useClinicalTrialStepper } from '@medifind/zustand';
import Step from './Step';
import styles from './StepShared.module.scss';

const AgeStep = ({ handleStepSubmit, isRequired, stepKey, trialCount, showOptional, loading }) => {
  const ageUnits = [
    { value: 'y', display: 'Year(s)' },
    { value: 'm', display: 'Month(s)' },
    { value: 'd', display: 'Day(s)' },
  ];
  const labelMap = {
    y: 'year',
    m: 'month',
    d: 'day',
  };
  const steps = useClinicalTrialStepper((state) => state.steps);
  const ageStep = steps.find(({ key }) => key === stepKey);
  const { data } = ageStep || {};
  const { age = { display: '', value: 0 }, ageUnit = ageUnits[0] } = data || {};

  const onChange = ({ data }) => {
    handleStepSubmit({
      data,
      doNotAdvance: true,
    });
  };

  const handleAgeChange = ({ target: { value, max, min } }) => {
    value = Math.max(Number(min), Math.min(Number(max), Number(value)));
    const stepValue = `${value}${ageUnit.value}`;
    const isPlural = parseInt(value, 10) !== 1 ? 's' : '';
    const stepDisplay = `${value} ${labelMap[ageUnit.value]}${isPlural}`;
    onChange({
      data: {
        age: { value, display: value },
        ageUnit,
        display: value && ageUnit ? stepDisplay : null,
        value: value && ageUnit ? stepValue : null,
      },
    });
  };

  const handleAgeUnitChange = (event) => {
    const { value } = event;
    const stepValue = `${age.value}${value}`;
    const isPlural = parseInt(age.value, 10) !== 1 ? 's' : '';
    const stepDisplay = `${age.value} ${labelMap[value]}${isPlural}`;
    onChange({
      data: {
        age,
        ageUnit: event,
        display: event && age.value ? stepDisplay : null,
        value: event && age.value ? stepValue : null,
      },
    });
  };

  return (
    <Step
      title="Age"
      titleId="age-type-label"
      subTitle="How old are you?"
      icon={<IconBirthdayCake />}
      optionsColStyles={styles['age-step']}
      isRequired={isRequired}
      trialCount={trialCount}
      showTrialCount
      showOptional={showOptional}
      loading={loading}
    >
      <div className={styles['form-row']}>
        <input
          id="age-number"
          type="number"
          min={0}
          max={500}
          onChange={handleAgeChange}
          value={age?.value || ''}
          placeholder="Enter Age"
          className={styles['age-input']}
          onKeyDown={(e) => {
            if (e.key === '-') e.preventDefault();
          }}
        />
        <Select
          id="age-type"
          labelId="age-type-label"
          onChange={handleAgeUnitChange}
          items={ageUnits}
          initialValue={ageUnit}
          selectedItem={ageUnit}
          classes={{ select: styles['age-unit'] }}
        />
      </div>
    </Step>
  );
};
export default AgeStep;
